import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { actions as cmsActions } from '../../reducers/cms.reducer';
import Button from '../common/Button.react';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import CardBody from '../common/card/CardBody.react';
var PageDelete = function PageDelete() {
  var _useParams = useParams(),
    contactID = _useParams.id;
  var dispatch = useDispatch();
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Delete Contact"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    onClick: function onClick() {
      dispatch({
        type: cmsActions.contacts,
        payload: {
          formData: {
            contactID: contactID
          },
          method: 'delete'
        }
      });
    },
    style: {
      width: 120
    },
    requireConfirmation: true,
    type: "close"
  }))));
};
export default PageDelete;